var c = (i, o, e) => new Promise((a, s) => {
  var g = (t) => {
    try {
      n(e.next(t));
    } catch (r) {
      s(r);
    }
  }, p = (t) => {
    try {
      n(e.throw(t));
    } catch (r) {
      s(r);
    }
  }, n = (t) => t.done ? a(t.value) : Promise.resolve(t.value).then(g, p);
  n((e = e.apply(i, o)).next());
});
import { selfAxios as l } from "@oppein/op-utils";
function y(i) {
  return c(this, null, function* () {
    const {
      data: o
    } = yield l.post(
      "/ucenterapi/internal/org/selectOrgRightListByCon",
      i
    );
    return o == null ? void 0 : o.data;
  });
}
export {
  y as postSelectOrgRightListByCon
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/internal/org/selectOrgRightListByCon/post.js
// module id = 1781
// module chunks = 41